import React from 'react'

const BookAppoinment = () => {
    return (
        <section className="bg-white py-16 px-4 text-center font-basefont">
            <div className="max-w-3xl mx-auto">
                <h2 className="text-4xl font-bold text-black mb-6">Let’s Connect.</h2>
                <p className="text-lg text-gray-700 leading-relaxed mb-8">
                    Whether you're starting a new project or refining an existing idea, the first step is a conversation.
                    Book a time that works for you, and let’s explore how we can bring your vision to life.
                </p>
                <a href="https://calendly.com/kirtirajgohil" target='_blank' rel="noreferrer" className="inline-block px-8 py-4 bg-basecolor text-white font-medium rounded-full shadow-lg hover:bg-opacity-90 transition-all">
                    BOOK  A  APPOINTMENT
                </a>
            </div>
        </section>


    )
}

export default BookAppoinment